import fp from 'lodash/fp';
import React from 'react';
import {
  nest,
  setDisplayName,
  wrapDisplayName
} from 'recompose';

export const nested = (components) => (Component) => {
  const Nested = fp.flow(
    fp.concat(components),
    fp.spread(nest)
  )(Component);

  return (
    process.env.NODE_ENV !== 'production' ?
      setDisplayName(wrapDisplayName(Component, 'nested')) :
      fp.identity
  )(Nested);
}

export const boxed = (Component) => {
  const Boxed = nested([
    ({ children }) => (
      <fieldset className='boxed'>
        {children}
      </fieldset>
    )
  ])(Component);

  return (
    process.env.NODE_ENV !== 'production' ?
      setDisplayName(wrapDisplayName(Component, 'boxed')) :
      fp.identity
  )(Boxed);
}



// WEBPACK FOOTER //
// ./src/containers/components/higher-order/nested.js